enum ModalToOpen {
	DuplicateCatalogDialog = "DuplicateCatalogDialog",
	DuplicateArticleDialog = "DuplicateArticleDialog",
	MergeConfirm = "MergeConfirm",
	MergeResolver = "MergeResolver",

	ShareTicketHandler = "ShareTicketHandler",

	CheckoutHandler = "CheckoutHander",
	CloneHandler = "CloneHandler",
	Clone = "Clone",
	PullHandler = "PullHandler",

	ImportModal = "ImportModal",

	SnippetAlreadyUseWarn = "SnippetAlreadyUseWarn",

	Loading = "Loading",

	MultilangActionConfirm = "MultilangActionConfirm",

	DiagramEditor = "DiagramEditor",
	HTMLEditor = "HTMLEditor",

	Merge = "Merge",
	CreateMergeRequest = "CreateMergeRequest",
	MergeRequestConfirm = "MergeRequestConfirm",
	CreateStorage = "CreateStorage",

	EnterpriseLogout = "EnterpriseLogout",
	RepositoryPermission = "RepositoryPermission",

	TemplateContentWarning = "TemplateContentWarning",
	PropertySettings = "PropertySettings",

	DocRootMissingModal = "DocRootMissingModal",

	CloudModal = "CloudModal",

	CreateWorkspaceForm = "CreateWorkspaceForm",
	EditWorkspaceForm = "EditWorkspaceForm",

	MediaPreview = "MediaPreview",
	FilePreview = "FilePreview",

	// Article dropdown modals
	ItemPropsEditor = "ItemPropsEditor",
	MarkdownEditor = "MarkdownEditor",
	BugsnagModal = "BugsnagModal",
	History = "History",
	UnsupportedElements = "UnsupportedElements",
	Share = "Share",
	NotificationSettings = "NotificationSettings",

	// Catalog dropdown modals
	CatalogPropsEditor = "CatalogPropsEditor",
	GetSharedTicket = "GetSharedTicket",
	Healthcheck = "Healthcheck",

	ActionConfirm = "ActionConfirm",

	ExportPdf = "ExportPdf",

	GesAdmin = "GesAdmin",

	DefaultModal = "DefaultModal",
	UnsavedChangesModal = "UnsavedChangesModal",
	UnsavedCommentModal = "UnsavedCommentModal",

	TauriGesSignIn = "TauriGesSignIn",
}

export default ModalToOpen;
